module.exports = __webpack_public_path__ + "media/images/Mastercard-1-4f4a37f0d32570beaacf740dda609267.svg";